<template>
    <!-- *********************************************
    *                     Info Block                 *
    ********************************************** -->
    <divider-generic icon="info" :title="t('bankassurance.subscribe.auto.step3.infoTitle')"/>
    <text-block-generic
    :params="{ label: t('bankassurance.subscribe.auto.step3.paymentLabel'), content: t('bankassurance.subscribe.auto.step3.paymentValue') }"/>
    <!-- Birth Date -->
    <input-calendar
    id="dataInicio"
    :params="dataInicioParams"
    :disabledDates="{ to: new Date() }"
    :inputValue="formData.dataInicio"
    @input="[emit('formDataChange', { field: 'dataInicio', inputValue: $event }), clearFieldError('dataInicioParams')]"/>
    <!-- *********************************************
    *                    Driver Block                *
    ********************************************** -->
    <divider-generic icon="person" :title="t('bankassurance.subscribe.auto.step3.driverTitle')"/>
    <selector-checkbox
    :label="t('bankassurance.subscribe.auto.step3.isHolderLabel')"
    :selected="isHolder"
    @clicked="holderToggleHandler"/>
    <!-- Name -->
    <input-generic
    v-if="!isHolder"
    id="driverName"
    :params="driverNameParams"
    :inputValue="formData.driverName"
    @input="[emit('formDataChange', { field: 'driverName', inputValue: $event}), clearFieldError('driverNameParams')]"/>
    <text-block-generic v-else :params="{ label: driverNameParams.labelText, content: titleCaseBuilder(formData.driverName) }"/>
    <!-- Birth Date -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step3.birthDateLabel'),
        content: isHolder ? getDate(getHolderData.birthDate) : getDate(formData.birthDate),
        classes: 'capitalize'
    }"/>
    <!-- Civil Status -->
    <dropdown-generic
    v-if="!isHolder"
    id="civilStatus"
    :params="civilStatusParams"
    :selectedOption="formData.civilStatus"
    :options="getDomainData('Civil Status').map(ele => {
        return { id: ele.code, text: ele.description }
    })"
    @clicked="[emit('formDataChange', { field: 'civilStatus', inputValue: $event}), clearFieldError('civilStatusParams')]"/>
    <text-block-generic
    v-else
    :params="{
        label: civilStatusParams.labelText,
        content: getDomainData('Civil Status').find(ele => ele.code === formData.civilStatus).description
    }"/>
    <!-- Fiscal Identification -->
    <input-generic
    v-if="!isHolder"
    id="fiscalIdentification"
    :params="fiscalIdentificationParams"
    :inputValue="formData.fiscalIdentification"
    @input="[emit('formDataChange', { field: 'fiscalIdentification', inputValue: $event }), emit('removeStepValidationError', 'fiscalIdentification'), clearFieldError('fiscalIdentificationParams')]"
    @onBlur="fiscalIdentificationValidation"/>
    <text-block-generic
    v-else
    :params="{
        label: fiscalIdentificationParams.labelText,
        content: formData.fiscalIdentification
    }"/>
    <!-- Identification -->
    <input-generic
    v-if="!isHolder"
    id="identification"
    :params="identificationParams"
    :inputValue="formData.identification"
    @input="[emit('formDataChange', { field: 'identification', inputValue: $event }), clearFieldError('identificationParams')]"/>
    <text-block-generic
    v-else
    :params="{
        label: identificationParams.labelText,
        content: formData.identification
    }"/>
    <!-- contact -->
    <input-generic
    v-if="!isHolder"
    id="contact"
    :params="contactParams"
    :inputValue="formData.contact"
    @input="[emit('formDataChange', { field: 'contact', inputValue: $event }), emit('removeStepValidationError', 'contact'), clearFieldError('contactParams')]"
    @onBlur="contactValidation"/>
    <dropdown-generic
    v-else
    :params="contactParams"
    :selectedOption="formData.contact"
    :options="getHolderData.contactList.map(el => {
        return { id: el.phone, text: el.phone }
    })"
    @clicked="[emit('formDataChange', { field: 'contact', inputValue: $event }), emit('removeStepValidationError', 'contact'), clearFieldError('contactParams')]"/>
    <!-- mobile -->
    <input-generic
    id="mobile"
    :params="mobileParams"
    :inputValue="formData.secondaryMobile"
    @input="[emit('formDataChange', { field: 'secondaryMobile', inputValue: $event }), emit('removeStepValidationError', 'secondaryMobile'), clearFieldError('mobileParams')]"
    @onBlur="mobileValidation"/>
    <!-- email -->
    <input-generic
    id="email"
    :params="emailParams"
    :inputValue="formData.email"
    @input="[emit('formDataChange', { field: 'email', inputValue: $event.trim() }), emit('removeStepValidationError', 'email'), clearFieldError('emailParams')]"
    @onBlur="emailValidation"/>
    <!-- Gender -->
    <dropdown-generic
    v-if="!isHolder"
    id="gender"
    :params="genderParams"
    :selectedOption="formData.gender"
    :options="getDomainData('Gender').map(ele => {
        return { id: ele.code, text: ele.description }
    })"
    @clicked="[emit('formDataChange', { field: 'gender', inputValue: $event }), clearFieldError('genderParams')]"/>
    <text-block-generic
    v-else
    :params="{
        label: genderParams.labelText,
        content: getDomainData('Gender').find(ele => ele.code === formData.gender).description
    }"/>
    <!-- Driver Licence Date -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step3.driverLicenceDateLabel'),
        content: getDate(formData.driverLicenceDate),
        classes: 'capitalize'
    }"/>
    <!-- Driver Licence Number -->
    <input-generic
    id="driverLicenceNumber"
    :params="driverLicenceNumberParams"
    :inputValue="formData.driverLicenceNumber"
    @input="[emit('formDataChange', { field: 'driverLicenceNumber', inputValue: $event }), clearFieldError('driverLicenceNumberParams')]"/>
    <!-- Adress -->
    <input-generic
    id="address1"
    :params="address1Params"
    :inputValue="formData.address1"
    @input="[emit('formDataChange', { field: 'address1', inputValue: $event }), clearFieldError('address1Params')]"/>
    <!-- Additional Adress -->
    <input-generic
    id="address2"
    :params="address2Params"
    :inputValue="formData.address2"
    @input="[emit('formDataChange', { field: 'address2', inputValue: $event }), clearFieldError('address2Params')]"/>
    <!-- postalCode -->
    <dropdown-generic
    v-if="!isHolder"
    id="postalCode"
    :params="postalCodeParams"
    :selectedOption="formData.postalCode"
    :options="getDomainData('Province').map(ele => {
        return { id: ele.code, text: ele.description }
    })"
    @clicked="postalCodeChangeHandler($event)"/>
    <text-block-generic
    v-else
    :params="{
        label: postalCodeParams.labelText,
        content: getDomainData('Province').find(ele => ele.code === formData.postalCode)?.description
    }"/>
    <!-- province -->
    <dropdown-generic
    v-if="!isHolder && formData.postalCode"
    id="province"
    :params="provinceParams"
    :selectedOption="formData.province"
    :options="getDomainData('City').map(ele => {
        return { id: ele.code, text: ele.description }
    })"
    @clicked="[emit('formDataChange', { field: 'province', inputValue: $event }), clearFieldError('provinceParams')]"/>
    <text-block-generic
    v-if="isHolder && getDomainData('City').length"
    :params="{
        label: provinceParams.labelText,
        content: getDomainData('City').find(ele => ele.code === formData.province).description
    }"/>
    <!-- country -->
    <dropdown-generic
    v-if="!isHolder"
    id="`country"
    :params="countryParams"
    :selectedOption="formData.country"
    :options="getDomainData('AddressCountry').map(ele => {
        return { id: ele.code, text: ele.description }
    })"
    @clicked="[emit('formDataChange', { field: 'country', inputValue: $event }), clearFieldError('countryParams')]"/>
    <text-block-generic
    v-else
    :params="{
        label: countryParams.labelText,
        content: getDomainData('AddressCountry').find(ele => ele.code === formData.country).description
    }"/>
    <!-- *********************************************
    *                    Object Block                *
    ********************************************** -->
    <divider-generic icon="car" :title="t('bankassurance.subscribe.auto.step3.objectTitle')"/>
    <!-- Licence Plate -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step3.licencePlateLabel'),
        content: formData.matriculaVeiculo
    }"/>
    <!-- First Licence Plate Date -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step3.firstLicenceDateLabel'),
        content: getDate(formData.dt1aMatriculaVeiculo),
        classes: 'capitalize'
    }"/>
    <!-- Brand -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step3.brandLabel'),
        content: getDomainData('AUTBrand').find(ele => ele.code === formData.marcaVeiculo).description
    }"/>
    <!-- Model -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step3.modelLabel'),
        content: getDomainData('AUTModel').find(ele => ele.code === formData.modeloVeiculo).description
    }"/>
    <!-- Categoria -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step3.categoryLabel'),
        content: t('bankassurance.subscribe.auto.step3.categoryValue')
    }"/>
    <!--  -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step3.cilindradaVeiculoLabel'),
        content: formData.cilindradaVeiculo
    }"/>
    <!-- *********************************************
    *                  Insurance Block               *
    ********************************************** -->
    <divider-generic icon="shield-insurance" :title="t('bankassurance.subscribe.auto.step3.insuranceTitle')"/>
    <!--  -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step3.packageLabel'),
        content: t('bankassurance.subscribe.auto.step3.packageValue')
    }"/>
    <!--  -->
    <text-block-generic
    :params="{
        label: t('bankassurance.subscribe.auto.step3.escalaoCapitalLabel'),
        content: getDomainData('AUTCapitalCRBAI').find(ele => ele.code === formData.escalaoCapitalRCCoberturas).description
    }"/>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
import SelectorCheckbox from '@/components/generic/selectors/checkbox/Checkbox'
import InputCalendar from '@/components/generic/inputs/Calendar'
import InputGeneric from '@/components/generic/inputs/Generic'
import DropdownGeneric from '@/components/generic/dropdowns/generic/Generic'

/* Vue */
import { ref, watch } from 'vue'

/* Assets */
import { PHONE_NUMBER, NIF } from '@/assets/constants/masks'
import { emailValidator, phoneNumberValidator } from '@/assets/scripts/validators'
import { getDate } from '@/assets/scripts/dateBuilders'
import { titleCaseBuilder } from '@/assets/scripts/strings'
import { getEmptyFieldsIdentifiers } from '@/assets/scripts/objects'
import { getElementOffsetTopPosition } from '@/assets/scripts/htmlManipulators'

/* Store */
import { mapGetters, mapActions } from '@/store/helpers/mappers'
import { moduleMapper } from '@/store/helpers/modules.map'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['formDataChange', 'formErrorsCleared', 'mandatoryListChangeHandler', 'resetShowMandatoryErrorsProp', 'scrollTo', 'showOverlayLoader', 'hideOverlayLoader', 'changeHolder', 'addStepValidationError', 'removeStepValidationError'])

/* mapActions & mapGetters */
const {	requestInsuranceDomainsList } = mapActions(moduleMapper.BANKASSURANCE_SUBSCRIBE)
const {	getDomainData, getHolderData } = mapGetters(moduleMapper.BANKASSURANCE_SUBSCRIBE)

/* props received
@clearFormErrors { Boolean } - Prop to remove of form errors
@formData { Object } - object with info for our current form
@mandatoryList { Array } Array of mandatory keys corresponding with our form
@showMandatoryErrors { Boolean } Prop to trigger display of mandatory errors
*/
const props = defineProps({
    clearFormErrors: Boolean,
    formData: Object,
    mandatoryList: Array,
    showMandatoryErrors: Boolean,
    isHolder: Boolean
})

const holderToggleHandler = () => {
    emit('formDataChange', { field: 'driverName', inputValue: !props.isHolder ? getHolderData.value.name : '' })
    clearFieldError('driverNameParams')
    emit('formDataChange', { field: 'civilStatus', inputValue: !props.isHolder ? getHolderData.value.maritalStatus.code : '' })
    clearFieldError('civilStatusParams')
    emit('formDataChange', { field: 'identification', inputValue: !props.isHolder ? getHolderData.value.identification : '' })
    clearFieldError('identificationParams')
    emit('formDataChange', { field: 'fiscalIdentification', inputValue: !props.isHolder ? getHolderData.value.fiscalIdentification : '' })
    clearFieldError('fiscalIdentificationParams')
    emit('formDataChange', { field: 'contact', inputValue: !props.isHolder ? getHolderData.value.contact : '' })
    clearFieldError('contactParams')
    emit('removeStepValidationError', 'contact')
    emit('formDataChange', { field: 'email', inputValue: !props.isHolder ? getHolderData.value.email : '' })
    clearFieldError('emailParams')
    emit('removeStepValidationError', 'email')
    emit('formDataChange', { field: 'gender', inputValue: !props.isHolder ? getHolderData.value.gender.code : '' })
    clearFieldError('genderParams')
    emit('formDataChange', { field: 'address1', inputValue: !props.isHolder ? getHolderData.value.insuranceEntityAddress.address1 : '' })
    clearFieldError('address1Params')
    emit('formDataChange', { field: 'address2', inputValue: !props.isHolder ? getHolderData.value.insuranceEntityAddress?.address2 ? getHolderData.value.insuranceEntityAddress.address2 : '' : '' })
    clearFieldError('address2Params')
    emit('formDataChange', { field: 'postalCode', inputValue: !props.isHolder ? getHolderData.value.insuranceEntityAddress.postalCode.code : '' })
    clearFieldError('postalCodeParams')
    emit('formDataChange', { field: 'province', inputValue: !props.isHolder ? getHolderData.value.insuranceEntityAddress.province.code : '' })
    clearFieldError('provinceParams')
    emit('formDataChange', { field: 'country', inputValue: !props.isHolder ? getHolderData.value.insuranceEntityAddress.country.code : 'ANG' })
    clearFieldError('countryParams')
    emit('changeHolder')
}

const postalCodeChangeHandler = async (data) => {
    emit('showOverlayLoader')

    try {
        await requestInsuranceDomainsList({ domain: 'City', params: { parentValue: data } })
        emit('formDataChange', { field: 'postalCode', inputValue: data })
        clearFieldError('postalCodeParams')

        emit('hideOverlayLoader')
    } catch (error) {
        emit('hideOverlayLoader')
        emit('showError', error.response.data)
    }
}
/**********************************************************************
*                              Start Date                             *
**********************************************************************/
const dataInicioParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.startDateLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.startDatePlaceholder'),
	mandatory: true,
	errorState: false,
    errorMessage: null
})

/**********************************************************************
*                                Name                                 *
**********************************************************************/
const driverNameParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.nameLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.namePlaceholder'),
	mandatory: true,
    maxLength: 42,
	errorState: false,
    errorMessage: null
})

/**********************************************************************
*                              Civil Status                           *
**********************************************************************/
const civilStatusParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.civilStatusLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.civilStatusPlaceholder'),
	mandatory: true,
	errorState: false,
    errorMessage: null
})

/**********************************************************************
*                           Fiscal Identification                     *
**********************************************************************/
const fiscalIdentificationParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.fiscalIdentificationLabel'),
	placeholder: t('bankassurance.subscribe.auto.step3.fiscalIdentificationPlaceholder'),
	mandatory: true,
    mask: NIF,
    maxLength: 14,
	errorState: false,
    errorMessage: null
})

const fiscalIdentificationValidation = () => {
    if (!!props.formData.fiscalIdentification.length && props.formData.fiscalIdentification.length < 14) {
        fiscalIdentificationParams.value.errorState = true
        fiscalIdentificationParams.value.errorMessage = t('invalidFiscalIdentificationError')

        emit('addStepValidationError', 'fiscalIdentification')
    }
}

/**********************************************************************
*                            Identification                           *
**********************************************************************/
const identificationParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.identificationLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.identificationPlaceholder'),
	mandatory: true,
    maxLength: 14,
	errorState: false,
    errorMessage: null
})

/**********************************************************************
*                                 Contact                             *
**********************************************************************/
const contactParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.contactLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.contactPlaceholder'),
	mandatory: true,
    mask: PHONE_NUMBER,
    maxLength: 14,
	errorState: false,
    errorMessage: null
})

const contactValidation = () => {
    if (!!props.formData.contact.length && !phoneNumberValidator(props.formData.contact)) {
        contactParams.value.errorState = true
        contactParams.value.errorMessage = t('phoneLengthOrError')

        emit('addStepValidationError', 'contact')
    }
}

/**********************************************************************
*                                 Mobile                             *
**********************************************************************/
const mobileParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.mobileLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.mobilePlaceholder'),
	mandatory: false,
    mask: PHONE_NUMBER,
    maxLength: 14,
	errorState: false,
    errorMessage: null
})

const mobileValidation = () => {
    if (!!props.formData.secondaryMobile.length && !phoneNumberValidator(props.formData.secondaryMobile)) {
        mobileParams.value.errorState = true
        mobileParams.value.errorMessage = t('phoneLengthOrError')

        emit('addStepValidationError', 'secondaryMobile')
    }
}

/**********************************************************************
*                                 Email                               *
**********************************************************************/
const emailParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.emailLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.emailPlaceholder'),
	mandatory: true,
    maxLength: 42,
	errorState: false,
    errorMessage: null
})

const emailValidation = () => {
    if (!!props.formData.email.length && !emailValidator(props.formData.email)) {
        emailParams.value.errorState = true
        emailParams.value.errorMessage = t('invalidEmailError')

        emit('addStepValidationError', 'email')
    }
}

/**********************************************************************
*                                 Gender                              *
**********************************************************************/
const genderParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.genderLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.genderPlaceholder'),
	mandatory: false,
	errorState: false,
    errorMessage: null
})

/**********************************************************************
*                        Driver Licence Number                        *
**********************************************************************/
const driverLicenceNumberParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.driverLicenceNumberLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.driverLicenceNumberPlaceholder'),
	mandatory: true,
    maxLength: 30,
	errorState: false,
    errorMessage: null
})

/**********************************************************************
*                                 Adress                              *
**********************************************************************/
const address1Params = ref({
	labelText: t('bankassurance.subscribe.auto.step3.adressLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.adressPlaceholder'),
	mandatory: true,
	errorState: false,
    errorMessage: null
})

/**********************************************************************
*                            Additional Adress                        *
**********************************************************************/
const address2Params = ref({
	labelText: t('bankassurance.subscribe.auto.step3.adress2Label'),
    placeholder: t('bankassurance.subscribe.auto.step3.adress2Placeholder'),
	mandatory: false,
	errorState: false,
    errorMessage: null
})

/**********************************************************************
*                              Postal Code                            *
**********************************************************************/
const postalCodeParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.postalCodeLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.postalCodePlaceholder'),
	mandatory: true,
	errorState: false,
    errorMessage: null
})

/**********************************************************************
*                                 Province                            *
**********************************************************************/
const provinceParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.provinceLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.provincePlaceholder'),
	mandatory: true,
	errorState: false,
    errorMessage: null
})

/**********************************************************************
*                                Country                              *
**********************************************************************/
const countryParams = ref({
	labelText: t('bankassurance.subscribe.auto.step3.countryLabel'),
    placeholder: t('bankassurance.subscribe.auto.step3.countryPlaceholder'),
	mandatory: true,
	errorState: false,
    errorMessage: null
})

const allFormFields = ref({
    dataInicioParams: dataInicioParams.value,
	driverNameParams: driverNameParams.value,
    civilStatusParams: civilStatusParams.value,
    identificationParams: identificationParams.value,
    fiscalIdentificationParams: fiscalIdentificationParams.value,
    contactParams: contactParams.value,
    mobileParams: mobileParams.value,
    emailParams: emailParams.value,
    genderParams: genderParams.value,
    driverLicenceNumberParams: driverLicenceNumberParams.value,
    address1Params: address1Params.value,
    address2Params: address2Params.value,
    provinceParams: provinceParams.value,
    postalCodeParams: postalCodeParams.value,
    countryParams: countryParams.value
})

watch(() => props.showMandatoryErrors, newValue => {
	if (newValue) showMandatoryErrorsHandler()
    emit('resetShowMandatoryErrorsProp')
})

watch(() => props.isHolder, newValue => {
    if (newValue) postalCodeChangeHandler(props.formData.postalCode)
})

const showMandatoryErrorsHandler = () => {
	/* Logic to scroll to first emptyField */

	const mandatoryFieldsEmptyList = getEmptyFieldsIdentifiers(props.formData, props.mandatoryList)

	if (mandatoryFieldsEmptyList.length) {
        emit('scrollTo', getElementOffsetTopPosition(mandatoryFieldsEmptyList[0]))

        mandatoryFieldsEmptyList.forEach(fieldName => {
            allFormFields.value[`${fieldName}Params`].errorState = true
            allFormFields.value[`${fieldName}Params`].errorMessage = t('mandatoryFieldError')
        })
    }
}

/**********************************************************************
*                                                                     *
*                          CLEAR ERRORS LOGIC                         *
*                                                                     *
***********************************************************************/
watch(() => props.clearFormErrors, () => {
    clearFormErrors()
    emit('formErrorsCleared')
})

const clearFieldError = (fieldName) => {
    allFormFields.value[fieldName].errorMessage = null
    allFormFields.value[fieldName].errorState = false
}

const clearFormErrors = () => {
    for (var fieldName in allFormFields.value) {
        clearFieldError(fieldName)
    }
}
</script>

<style lang="scss" scoped>
</style>
